import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router";
import deepcopy from "deepcopy";
import './App.css';
import * as d3 from 'd3-fetch';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import FullscreenExit from '@material-ui/icons/FullscreenExit';
import Fullscreen from '@material-ui/icons/Fullscreen';

import CircularProgress from '@material-ui/core/CircularProgress';
import FilterByVehicleType from './FilterByVehicleType';
import FilterByYear from './FilterByYear';
import FilterByText from './FilterByText';
import FilterBySeverity from './FilterBySeverity';
import FilterByAlcohol from './FilterByAlcohol';
import FilterReset from './FilterReset';
import LayerOptions from './LayerOptions';
import Map from './Map';
import Sun  from './Sun';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import kshLogo_hun from './icons/kshlogo_csscolor.svg';
import kshLogo_eng from './icons/hcso_logo.svg';

import queryString from 'query-string';

import * as _ from 'lodash';

// import { geolocated } from "react-geolocated";

import text from './text';

const DATA_URL='balesetek.json';
const DATA_URL_DAYS = 'balesetek_napok.json';

const VEHICLE_TYPES_FULL = {
  motorcycle: "111",
  car: "112",
  bus: "113",
  truckSmall: "121",
  truckBig: "122",
  tow: "124",
  special: "127",
  tram: "214",
  trolleybus: "215",
  trainLocal: "216",
  train: "217",
  bicycle: "318",
  scooter: "319",
  chariot: "322",
  other: "323",
  walker: "411"
}

const VEHICLE_TYPES_REDUCED = {
  motorcycle: 1,
  car: 2,
  bus: 3,
  truck: 4,
  bicycle: 5,
  scooter: 6,
  walker: 7,
  other: 8
}

const reduceVehicle = (vt) => {
  switch (vt) {
    case VEHICLE_TYPES_FULL.motorcycle:
      return VEHICLE_TYPES_REDUCED.motorcycle;

    case VEHICLE_TYPES_FULL.car:
        return VEHICLE_TYPES_REDUCED.car;

    case VEHICLE_TYPES_FULL.bus:
        return VEHICLE_TYPES_REDUCED.bus;

    case VEHICLE_TYPES_FULL.truckSmall:
    case VEHICLE_TYPES_FULL.truckBig:
    case VEHICLE_TYPES_FULL.tow:
    case VEHICLE_TYPES_FULL.special:
      return VEHICLE_TYPES_REDUCED.truck;

    case VEHICLE_TYPES_FULL.bicycle:
      return VEHICLE_TYPES_REDUCED.bicycle;

    case VEHICLE_TYPES_FULL.scooter:
      return VEHICLE_TYPES_REDUCED.scooter;

    case VEHICLE_TYPES_FULL.walker:
      return VEHICLE_TYPES_REDUCED.walker;

    default:
      return VEHICLE_TYPES_REDUCED.other;
  }
}

// check is it a mobile device or not
const isMobile = () => {
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    return true;
  } else {
    return false;
  }
}

function NumberFormat(x){
	return parseInt(x).toLocaleString('en-US').replace(',', ' ');
  }
const language = window.location.hash === '#en' ? 'eng' : 'hun';

const isInHun = (c1, c2) => {
  // west, north
  if(c1 < 16.112164) return false;
  if(c1 > 22.925896) return false;
  // east, south
  if(c2 < 45.735364) return false;
  if(c2 > 48.586290) return false;
  return true;
} 

// convert data
const processData = d => {
  return {
    ...d,
    geometry: {
      ...d.geometry,
      coordinates: [d.geometry.coordinates[1] - 19, d.geometry.coordinates[0] - 47]
      
    },
    properties: {
      //...d.properties,
      road: d.properties.KU_SZ_1,
      date: d.properties.BAL_DATE,
      //settlement: d.properties.M009T,
      severity: Math.pow(2, +d.properties.JAAA029),
      severity30: Math.pow(2, +d.properties.JAAA030),
      alcohol: +d.properties.JAAA022 > 0 && +d.properties.JAAA022 < 6 ? Math.pow(2, +d.properties.JAAA022) : 32,
      vehicle: reduceVehicle(d.properties.JAAB001),
      // search: [ // TODO
      //   ' ',
      //   d.properties.M009T.toUpperCase(  ).replace(/BUDAPEST\s+(\d\d)\.\s+KER\.$/, 'BUDAPEST BUDAPEST$1'),
      //   d.properties.KU_SZ_1.toUpperCase(),
      //   d.properties.BAL_DATE,
      //   d.properties.BAL_DATE.substring(0,7),
      //   ' '
      //   ].join(' '),
        inHun: isInHun(d.geometry.coordinates[1], d.geometry.coordinates[0])
    }
  }
};

const CENTER_COORDS = {
  latitude:  47.180086,
  longitude: 19.503736
}

const INITIAL_VIEW_STATE = {
  ...CENTER_COORDS,
  zoom: 6.8,
  bearing: 0,
  pitch: 0,
  maxZoom: 13,
  transitionDuration: 1000
}
const DEFAULT_INITIAL_VIEW_STATE = deepcopy(INITIAL_VIEW_STATE);
const INITIAL_MINI_VIEW_STATE = {
  ...CENTER_COORDS,
  zoom: 4.7,
  bearing: 0,
  pitch: 0,
  transitionDuration: 1000
}
const INITIAL_FILTERS = {
  filterText: '',
  severity: 0b1110,
  alcohol: 0b111110
}

const INITIAL_LAYER_OPTIONS = {
  baseMap: {
    visible: true
  },
  scatterplot: {
    visible: true
  },
  hexagon: {
    visible: false,
    elevationScale: 100,
    radius: 1000
  },
  tiles: {
    visible: true
  }
}

const DEFAULT_LAYER_OPTIONS = deepcopy(INITIAL_LAYER_OPTIONS);

const INITIAL_YEAR_FILTER = {
  f2018: true,
  f2017: true,
  f2016: true,
  f2015: true
}

const INITIAL_VEHICLE_FILTER = {
  motorcycle: true, //motorcycle
  car: true, //car
  bus: true, //bus
  truck: true, //truck
  bicycle: true, //bicycle
  scooter: true, //scooter
  walker: true, //walker
  other: true  //other
}

const INITIAL_SUN_DATA = {
  type: "month",
  data: []
}

function App (props) {
  const params = queryString.parse(props.location.search);
  const [query, setQuery] = useState(params);

  const [sunSize, setSunSize] = useState(300);
  const [mapSize, setMapSize] = useState("100%");
  const [sideMenuBar, setSideMenuBar] = useState(isMobile());
  const [accidentsNumber, setAccidentsNumber] = useState(0);
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [sunAllData, setAllSunData] = useState([]);
  const [sunData, setSunData] = useState(INITIAL_SUN_DATA);
  const [layerOptions, setLayerOptions] = useState(INITIAL_LAYER_OPTIONS);
  const [filterVehicle, setFilterVehicle] = useState(INITIAL_VEHICLE_FILTER);
  const [filterYear, setFilterYear] = useState(INITIAL_YEAR_FILTER);
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [filterFn, setFilterFn] = useState({ f: () => true});
  const [fullscreen, setFullscreen] = useState(false);
  const [isSun, setIsSun] = useState(false);
  const [fullSun, setFullSun] = useState(false);

  const onLoad = () => {
    if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
      document.addEventListener("touchmove", function (e) { e.preventDefault(); }, false);
    }
    // remove right click event  
    document.addEventListener("contextmenu", function (e) { e.preventDefault(); }, false);
    sunResizeHnd();
    menuHide();
    d3.json(DATA_URL).then(data => {
      //const all = data.features.map(processData);
      const all = data;
      setData(all);
      setAllData(all);
      textSizeHandle();
      loadAnimationEnd();
      setSunData({ "type": "month", data : all});
    }).catch(err => {console.log("Hiba: ", err);});

    d3.json(DATA_URL_DAYS).then(data => {
      setAllSunData(data);
    }).catch(err => {console.log('Hiba: ', err)})
    
    const qsFilterYear = {...filterYear}
    for (const yearKey in INITIAL_YEAR_FILTER)
      if (yearKey in query) qsFilterYear[yearKey] = false;
    setFilterYear(qsFilterYear)
    
    const qsFilterVehicle = {...filterVehicle}
    for (const vehicleKey in INITIAL_VEHICLE_FILTER)
      if (vehicleKey in query)  qsFilterVehicle[vehicleKey] = false;
    setFilterVehicle(qsFilterVehicle)

    const qsFilters = {...filters}
    if ("filterText" in query)
      qsFilters["filterText"] = query["filterText"];
    if ("severity" in query)
      qsFilters["severity"] = query["severity"];
    if ("alcohol" in query)
      qsFilters["alcohol"] = query["alcohol"];

    if ("scatterplot" in query) {
      const newLayers = {...layerOptions};
      newLayers["hexagon"]["visible"] = false;
      newLayers["scatterplot"]["visible"] = true;
      setLayerOptions(newLayers);
    }
    if ("sun" in query) {
      setFullSun(true)
    }

    setFilters(qsFilters);
    window.addEventListener("resize", sunResizeHnd);
    document.getElementById('main-sun').addEventListener('click', sunClickHnd);
    document.getElementById('map').addEventListener('click', mapClickHnd);
  }
  const firstState = () =>{
    const queryViewState = {...DEFAULT_INITIAL_VIEW_STATE}

    if ("bearing" in query)
      queryViewState["bearing"] = parseFloat(query["bearing"]);
    if ("latitude" in query)
      queryViewState["latitude"] = parseFloat(query["latitude"]);
    if ("longitude" in query)
      queryViewState["longitude"] = parseFloat(query["longitude"]);
    if ("pitch" in query)
      queryViewState["pitch"] = parseFloat(query["pitch"]);
    if ("zoom" in query)
      queryViewState["zoom"] = parseFloat(query["zoom"]);
    return queryViewState;
  }
  const [viewState, setViewState] = useState(firstState);
  // run once on load
  useEffect(onLoad, []);

  const setIcon = () => {
    if(language === 'eng') {
      return (
        <img src={kshLogo_eng} className="ksh-logo" alt="ksh-logo"/>
      );
    } else {
      return (
        <img src={kshLogo_hun} className="ksh-logo" alt="ksh-logo"/>
      );
    }
  }

  // handling filter change
  const onFilterChange = name => value => setFilters({
    ...filters,
    [name]: value
  });

  const onTextChange = onFilterChange('filterText');
  const onSeverityChange = onFilterChange('severity');
  const onAlcoholChange = onFilterChange('alcohol');

  // const timeOutDebouncer = useRef(null);
  // useEffect(() => {
  //   timeOutDebouncer.current = setTimeout(() => onFilterTextChange(filterText), 300);
  //   return () => {
  //     timeOutDebouncer.current && clearTimeout(timeOutDebouncer.current);
  //   };
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [filterText]);

  // useEffect(() => {
  //   if (filterText !== filters.filterText) {
  //     setFilterText(filters.filterText);
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [filters]);

  const onVehicleChange = (e) => {
    setFilterVehicle({
      ...filterVehicle,
      [e]: !filterVehicle[e]}
    );
  }

  const onYearChange = (e) => {
    setFilterYear({
      ...filterYear,
      [e]: !filterYear[e]}
    );
  }

  // handling layers change
  const onLayersChange = layerOptions => {
    setLayerOptions(layerOptions);
    updateQueryString();
  };

  // handling option update
  const createTextFilter = filterText => {
    const f = filterText.trim()
      .replace(/[,;.:\s]+$/, '')
      .toUpperCase()
      .split(/[,;.:\s]+/);
      //console.log(f);
    return f[0] === '' ?
      () => true :
      d => f.some(t => d.properties.road==t );
  }

   const carFilter = (d) => {
    return d.properties.vehicle === VEHICLE_TYPES_REDUCED.car;
  }

  const motorcycleFilter = (d) => {
    return d.properties.vehicle === VEHICLE_TYPES_REDUCED.motorcycle;
  }

  const busFilter = (d) => {
    return d.properties.vehicle === VEHICLE_TYPES_REDUCED.bus;
  }

  const truckFilter = (d) => {
    return d.properties.vehicle === VEHICLE_TYPES_REDUCED.truck;
  }

  const bicycleFilter = (d) => {
    return d.properties.vehicle === VEHICLE_TYPES_REDUCED.bicycle;
  }

  const schooterFilter = (d) => {
    return d.properties.vehicle === VEHICLE_TYPES_REDUCED.scooter;
  }

  const walkerFilter = (d) => {
    return d.properties.vehicle === VEHICLE_TYPES_REDUCED.walker;
  }

  const otherFilter = (d) => {
    return d.properties.vehicle === VEHICLE_TYPES_REDUCED.other;
  }

  const year2018Filter = (d) => {
    return d.properties.date.includes("2018");
  }

  const year2017Filter = (d) => {
    return d.properties.date.includes("2017");
  }

  const year2016Filter = (d) => {
    return d.properties.date.includes("2016");
  }

  const year2015Filter = (d) => {
    return d.properties.date.includes("2015");
  }

  const onFilterUpdate = () => {
    const { severity, alcohol, filterText } = filters;
    const textFilter = createTextFilter(filterText);
    const filterFunction = d =>
      // ((d.properties.severity & severity) || (d.properties.severity30 & severity)) &&
      (d.properties.severity30 & severity) && // csak a 30-al késöbbit figyelem
      d.properties.alcohol & alcohol && textFilter(d) &&
      (
        (motorcycleFilter(d) & filterVehicle.motorcycle) ||
        (carFilter(d) & filterVehicle.car) ||
        (busFilter(d) & filterVehicle.bus) ||
        (truckFilter(d) & filterVehicle.truck) ||
        (bicycleFilter(d) & filterVehicle.bicycle) ||
        (schooterFilter(d) & filterVehicle.scooter) ||
        (walkerFilter(d) & filterVehicle.walker) ||
        (otherFilter(d) & filterVehicle.other)
      ) && (
        (year2018Filter(d) & filterYear.f2018) ||
        (year2017Filter(d) & filterYear.f2017) ||
        (year2016Filter(d) & filterYear.f2016) ||
        (year2015Filter(d) & filterYear.f2015)
      );

    const currentData = data.filter(filterFunction);
    if (fullSun) {
      const fullData  = sunAllData.filter( d =>{
        const date = new Date(d.date)
        const severity30 = Math.pow(2, +d.severity)
        return filterYear["f"+date.getFullYear()] && severity30 & severity && d.alcohol & alcohol && (
          (motorcycleFilter(d) & filterVehicle.motorcycle) ||
          (carFilter(d) & filterVehicle.car) ||
          (busFilter(d) & filterVehicle.bus) ||
          (truckFilter(d) & filterVehicle.truck) ||
          (bicycleFilter(d) & filterVehicle.bicycle) ||
          (schooterFilter(d) & filterVehicle.scooter) ||
          (walkerFilter(d) & filterVehicle.walker) ||
          (otherFilter(d) & filterVehicle.other)
        )
      }) 

      setSunData({ type: "day", data : fullData});
    }
    else {
       setSunData({
         type: "month", 
         data: currentData
      }); 
      setFilterFn({ f: filterFunction});
    }
    updateAccidentsNumber(currentData);
    updateQueryString()
  }

  const updateQueryString = () =>{
    const sq = {...query};

    for (const year of Object.keys(filterYear))
      if (!filterYear[year])
        sq[year]= "f";
      else delete sq[year];
    for (const vehicle of Object.keys(filterVehicle))
      if (!filterVehicle[vehicle])
        sq[vehicle]= "f";
      else delete sq[vehicle]  

    if (filters.filterText != "")
        sq["filterText"] = filters.filterText
    else delete sq["filterText"]

    if (INITIAL_FILTERS.severity != filters.severity)
        sq["severity"] = filters.severity;
    else delete sq["severity"]

    if (INITIAL_FILTERS.alcohol != filters.alcohol)
        sq["alcohol"] = filters.alcohol;
    else delete sq["alcohol"]

    if (fullSun)
      sq["sun"] = "t";
    else delete sq["sun"]

    if (layerOptions.scatterplot.visible)
      sq["scatterplot"] = "t";
    else delete sq["scatterplot"]

    if (DEFAULT_INITIAL_VIEW_STATE.bearing != viewState.bearing)
      sq["bearing"] = viewState.bearing;
    else delete sq["bearing"]

    if (DEFAULT_INITIAL_VIEW_STATE.latitude != viewState.latitude)
      sq["latitude"] = viewState.latitude;
    else delete sq["latitude"]

    if (DEFAULT_INITIAL_VIEW_STATE.longitude != viewState.longitude)
      sq["longitude"] = viewState.longitude;
    else delete sq["longitude"]
      
    if (DEFAULT_INITIAL_VIEW_STATE.pitch != viewState.pitch)
      sq["pitch"] = viewState.pitch;
    else delete sq["pitch"]

    if (DEFAULT_INITIAL_VIEW_STATE.zoom != viewState.zoom)
      sq["zoom"] = viewState.zoom;
    else delete sq["zoom"]


    const searchParams = queryString.stringify({...sq});
    props.history.push(`?${searchParams}`); 
    setQuery(sq)
  }
  useEffect(onFilterUpdate, [filters, allData, filterVehicle, filterYear]);

  //const onViewStateChange = useCallback(({viewState}) => setViewState(viewState), []);
  const onViewStateChange = _.debounce(({viewState}) => setViewState(viewState), 200);

  //Update query after change viewState
  useEffect(() => updateQueryString(), [viewState]);
  

  // handling sidebar menu button
  const menuHide = () => {
    let menu = document.getElementById('menu-content');
    if(sideMenuBar) {
      document.body.classList.remove("in")
      menu.style.display = 'none';
      setSideMenuBar(!sideMenuBar);
    } else {
      document.body.classList.add("in")
      menu.style.display = 'block';
      setSideMenuBar(!sideMenuBar);
    }
  }

  const updateAccidentsNumber = (currentData) => {
    setAccidentsNumber(currentData.length);
  }
  const getMiniSize = () =>{
    if(window.innerWidth <= 600) {
      return 130;
    } else if(window.innerWidth <= 1000) {
      return 200;
    }
    return 300
  }

  //  handling sun resize
  const sunResizeHnd = () => {
    const size = getMiniSize();
    if (!isSun  && !fullSun) {
      document.getElementById("miniSunTitle").style.bottom= (size+15) +"px";
      document.getElementById("miniSunTitle").style.width= size +"px";
      setSunSize(size)
      if (document.getElementById('sunContainer') != null)
        document.getElementById('sunContainer').removeAttribute("style")
      }
    else {  
      if(window.innerHeight < window.innerWidth) {
        setSunSize(window.innerHeight);
        document.getElementById('sunContainer').style.left = ((window.innerWidth - window.innerHeight) / 2) + 'px';
      } else {
        setSunSize(window.innerWidth);
        document.getElementById('sunContainer').style.top = ((window.innerHeight - window.innerWidth) / 2) + 'px';
      } 
  }
    textSizeHandle();
  }

  const textSizeHandle = () => {
    let fs = document.getElementsByTagName('HTML')[0].style;
    let newFontSize = (window.innerHeight + window.innerWidth) / 120 + "px";
      if((Number((newFontSize).slice(0, -2)) < 16)) {
        fs.fontSize = newFontSize;
      } else {
        fs.fontSize = "16px";
      }
  }

   useEffect(() => {

  });
  useEffect(() => {
    window.removeEventListener('resize', sunResizeHnd)
    document.getElementById('main-sun').removeEventListener('click', sunClickHnd)
    document.getElementById('map').removeEventListener('click', mapClickHnd)
    if (fullSun != isSun) {
      if (fullSun) sunFull();
      else mapFull();
    }
    window.addEventListener("resize", sunResizeHnd);
    document.getElementById('main-sun').addEventListener('click', sunClickHnd);
    document.getElementById('map').addEventListener('click', mapClickHnd);
  }, [fullSun,isSun])

  const loadAnimationEnd = () => {
      document.getElementById('loading-div').style.display = 'none';
    }

   const sunClickHnd = () => {
    if(!fullSun) {
      setFullSun(true);
    }
  }
  const sunFull = () =>{
    const size = getMiniSize();
      document.getElementById('main-sun').classList.add("large");
      document.getElementById('map').style.bottom= (size+35) +"px";
      document.getElementById('map').style.left= "5px";
      document.getElementById("miniMapTitle").style.bottom= (size+35) +"px";
      document.getElementById("miniMapTitle").style.width= size +"px";
      setMapSize(size);
      if(window.innerHeight < window.innerWidth) {
        setSunSize(window.innerHeight);
        document.getElementById('sunContainer').style.left = ((window.innerWidth - window.innerHeight) / 2) + 'px';
      } else {
        setSunSize(window.innerWidth);
        document.getElementById('sunContainer').style.top = ((window.innerHeight - window.innerWidth) / 2) + 'px';
      } 
      filterDefault()
      setViewState(INITIAL_MINI_VIEW_STATE)
      setIsSun(true);
  }
  const mapClickHnd = () =>{
    if(fullSun) {
      setViewState(DEFAULT_INITIAL_VIEW_STATE)
      setFullSun(false)
    }
  }
  const mapFull = () =>{
    const size = getMiniSize();
    document.getElementById('main-sun').classList.remove("large");
    document.getElementById('sunContainer').removeAttribute("style")
    /* document.getElementById('sunContainer').style.left = '0px';
    document.getElementById('sunContainer').style.top = '15px'; */
    document.getElementById("miniSunTitle").style.bottom= (size+15) +"px";
    document.getElementById("miniSunTitle").style.width= size +"px";
    setSunSize(size);
    setMapSize("100%");
    setViewState({...DEFAULT_INITIAL_VIEW_STATE, width : window.innerWidth, height: window.innerHeight})
    setIsSun(false);
    filterDefault()
  }

  const tglFullScreen = () => {
    if(!document.fullscreen) {
      document.documentElement.requestFullscreen();
      setFullscreen(true);
    } else {
      document.exitFullscreen();
      setFullscreen(false);
    }
  }

  //Reset all filter
  const filterDefault = () => {
    onTextChange('');
    //setViewState(DEFAULT_INITIAL_VIEW_STATE);
    setLayerOptions(DEFAULT_LAYER_OPTIONS);
    setFilterVehicle(INITIAL_VEHICLE_FILTER);
    setFilterYear(INITIAL_YEAR_FILTER);
    setFilters(INITIAL_FILTERS);
    onFilterUpdate();
  }

  const screenButtonAnimate = () => {
    if(fullscreen) {
      return(
        <FullscreenExit/>
      );  
    } else {
      return(
        <Fullscreen/>
      );  
    }
  }

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  document.title = text[language].title;

  return (
    <div className="App">
      <div className="loading-div" id="loading-div">
        <CircularProgress className="circular-progress"
          color="primary"
        />
      </div>
    <div className="main-content">

        <div className="btn-div">
          <div className="menu-button">
            <IconButton className="menu-hide-btn"
              aria-label="More"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={menuHide}
              >
              <MoreVertIcon />
            </IconButton>
          </div>
          <div className="fullscreen-button">
            <IconButton
              aria-label="More"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={tglFullScreen}
              >
              {screenButtonAnimate()}
            </IconButton>
          </div>
        </div>

          <div id='map' className={isSun?"miniMap":"fullMap"}>
            <Map
              data={data}
              layerOptions={layerOptions}
              viewState={viewState}
              onViewStateChange={onViewStateChange}
              filterFn={filterFn.f}
              size={mapSize}
            />
            <div className="miniMapTitle" id="miniMapTitle">{text[language].miniText.map}</div>
          </div>
          <div className="titleLine">
            {setIcon()}
            <h1 className="title">{text[language].title} </h1>
           
          </div>
          <div className="info-text" dangerouslySetInnerHTML={{ __html: text[language].infoText}}></div>
          <div className="msg right">{NumberFormat(accidentsNumber)}{' '+text[language].accident}</div>
          <div className="datasource">{text[language].datasource}</div>
      </div>

      <div className={isSun?"menu-content sunMenu":"menu-content mapMenu"} id="menu-content">
        <div className="menu-scroll">
{/*           <FilterByText
            onChange={onTextChange}
            value={filters.filterText}
          /> */}
          <FilterByYear
            filter={filterYear}
            onChange={onYearChange}
          />

          <LayerOptions
            layers={layerOptions}
            onLayersChange={onLayersChange}
          />

          <FilterBySeverity
            filter={filters.severity}
            onChange={onSeverityChange}
          />

          <FilterByAlcohol
              filter={filters.alcohol}
              onChange={onAlcoholChange}
          />

          <FilterByVehicleType
            filter={filterVehicle}
            onChange={onVehicleChange}
          />
          <FilterReset
            filterReset={filterDefault}
          />
          <div className="menuBottom">
            <div className="filterReset modszer">
              <Button color="primary" onClick={handleClickOpen}>
                {text[language].methodology}
              </Button>
            </div>
            <div className="mapHelp">
                <div>{text[language].mapHelp.left}</div>
                <div>{text[language].mapHelp.right}</div>
                <div>{text[language].mapHelp.center}</div>
            </div>
          </div>

          <Dialog
            open={open}
            onClose={handleClose}
            className="infoDialog"
          >
              <DialogTitle>{text[language].infoTitle}</DialogTitle>
              <DialogContent>
                {text[language].info}
              </DialogContent>
              <DialogActions>
                <Button variant="contained"
                className="closeButton"
                color="primary"
                onClick={() => setOpen(false)}>{text[language].close}</Button>
              </DialogActions>
          </Dialog>

        </div>

      </div>
      <div className="sidebar">
          <div id="main-sun" className={!isSun?"miniSun":"fullSun"}>
            <Sun
              options={sunData}
              size={sunSize}
            />
            <div className="miniSunTitle" id="miniSunTitle">{text[language].miniText.sun}</div>
          </div>
      </div>
  </div>
);
}

//export default geolocated()(App);
export default withRouter(App);
